import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getHospitalNotifySelector } from '../selectors'
import { HospitalNotifyConstants } from '../store/hospitalNotify.constants'
import { IHospitalNotifyState } from '../store/hospitalNotify.types'

export function* setPotentialRegistry() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const hospitalNotifyState: IHospitalNotifyState = yield select(getHospitalNotifySelector)
  const { inputRows } = procedureState
  const { potentialRegistry } = hospitalNotifyState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === HospitalNotifyConstants.SET_POTENTIAL_REGISTRY) {
        //@ts-ignore
        input.props.savedValues = potentialRegistry
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setPotentialRegistrySaga() {
  yield takeLatest([HospitalNotifyConstants.SET_POTENTIAL_REGISTRY], setPotentialRegistry)
}
